import { ContactSidebarMainAvailability } from './Main/Availability';
import { ContactSidebarMainLocations } from './Main/Locations';
import { ContactSidebarJobPreferences } from './Main/JobPreferences';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { useContext } from 'react';
import some from 'lodash/some';
import { ContactSidebarNotes } from 'features/ContactSidebar/Subcomponents/Main/Notes';

export const ContactSidebarMain = () => {
  const { hasPreferences } = useContext(ContactSidebarContext);

  return (
    <main className="flex flex-1 flex-col gap-3 -mx-2">
      {some(Object.values(hasPreferences)) ? (
        <>
          <ContactSidebarNotes />
          <ContactSidebarMainAvailability />
          <ContactSidebarMainLocations />
          <ContactSidebarJobPreferences />
        </>
      ) : (
        <p className="italic text-neutral-dark text-sm">
          This teacher has not provided any preference or availability information yet.
        </p>
      )}
    </main>
  );
};

ContactSidebarMain.displayName = 'ContactSidebarMain';
